module.exports = fox._r("images/opa75.png", __webpack_public_path__ + "images/opa75.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/opa75.png
// module id = 1088
// module chunks = 4